import type { SupportedLangs } from "@/i18n/types";

export const accountUserKindList = [
  "personal:free",
  "personal:pro",
  "personal:admin",
  "client:admin",
  "client:user",
  "aa:system-admin",
  "aa:admin",
  "aa:developer",
  "aa:user",
  "archived",
] as const;

export const changeableAccountUserKindList = [
  "personal:free",
  "aa:user",
] as const;

/** 管理者画面でのユーザー種別変更候補 (現在の種別 + この3種類を表示) */
export const adminChangeableAccountUserKindList = [
  "personal:free",
  "aa:user",
  "aa:developer",
] as const;

/** aa:system-admin 操作時のユーザー種別変更候補 (aa:admin / aa:system-admin への昇格も可能) */
export const systemAdminChangeableAccountUserKindList = [
  "personal:free",
  "aa:user",
  "aa:developer",
  "aa:admin",
  "aa:system-admin",
] as const;

export type AccountRaw = {
  uid: string;
  idp_uid: string;
  email: string;
  display_name: string;
  email_verified: boolean;
  use_mfa: boolean | null;
  locale: SupportedLangs | null;
  identity_provider: string;
  latest_logined_at: string;
  logins_count: number;
  user_kind: (typeof accountUserKindList)[number];
  default_org_id: string;
  max_num_owned_orgs: number | null;
  num_owned_orgs: number;
  picture_type: "color" | "image";
  picture_color: string;
  picture_image_url: string;
  is_setup_finished: string;
  is_disabled: boolean;
  created_at: string;
  updated_at: string;
};

export type InvitedAccountRaw = Omit<AccountRaw, "uid">;

export type InvitedAccountItem = InvitedAccountRaw & { is_new_user: true };

export const toInvitedAccountItem = (
  account: InvitedAccountRaw
): InvitedAccountItem => ({
  ...account,
  is_new_user: true,
});

export type AccountItem =
  | (AccountRaw & { is_new_user?: false })
  | InvitedAccountItem;

export const getIsAAMemberOrAbove = (account: AccountItem | null) => {
  if (!account) return false;
  const { user_kind } = account;
  return (
    user_kind === "aa:system-admin" ||
    user_kind === "aa:admin" ||
    user_kind === "aa:user" ||
    user_kind === "aa:developer"
  );
};

export const getIsAAAdminOrAbove = (account: AccountRaw | null) => {
  if (!account) return false;
  const { user_kind } = account;
  return user_kind === "aa:system-admin" || user_kind === "aa:admin";
};
export const getIsAADeveloperOrAbove = (account: AccountRaw | null) => {
  if (!account) return false;
  const { user_kind } = account;
  return (
    user_kind === "aa:developer" ||
    user_kind === "aa:system-admin" ||
    user_kind === "aa:admin"
  );
};

// emailのドメインが@algo-artis.comのユーザーの場合はtrue
export const getIsAlgoArtisEmailUser = (account: AccountRaw | null) => {
  if (!account) return false;
  const { email } = account;
  return email.endsWith("@algo-artis.com");
};

export const getAccountId = ({ account }: { account: AccountItem }) => {
  return account.is_new_user ? account.idp_uid : account.uid;
};
